/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import PropTypes from 'prop-types';
import React from 'react';

export default class Provider extends React.Component {
  getChildContext() {
    return {
      store: this.props.store
    };
  }

  render() {
    return this.props.children;
  }
}

Provider.childContextTypes = {
  store: PropTypes.object
};
